export const customTheme = {
  accordion: {
    root: {
      base: "divide-y divide-gray-200 border-gray-200 dark:divide-gray-700 dark:border-gray-700",
      flush: {
        off: "rounded-lg border",
        on: "border-b",
      },
    },
    content: {
      base: "last:rounded-b-lg dark:bg-gray-900 first:rounded-t-lg",
    },
    title: {
      arrow: {
        base: "h-6 w-6 shrink-0 mx-5",
        open: {
          off: "",
          on: "rotate-180",
        },
      },
      base: "flex items-center rounded-md text-left bg-white my-2 w-full p-5 rounded focus:ring-secondary-50 focus:bg-white border-none hover:bg-white/44 ",
      flush: {
        off: "hover:bg-gray-100 focus:ring-4  dark:hover:bg-gray-800 dark:focus:ring-gray-800",
        on: "bg-transparent dark:bg-transparent",
      },
      heading: "w-full",
      open: {
        off: "",
        on: "text-gray-900 bg-gray-100 dark:bg-gray-800 dark:text-white",
      },
    },
  },
};
